import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import Dashboard from "../pages/Dashboard";
import LandingPage from "../pages/Landing/LandingPage";

const ConditionalRoute = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user) {
    navigate("/dashboard");
    return <Dashboard />;
  }

  return <LandingPage />;
};

export default ConditionalRoute;
